import { Component, OnInit, AfterViewInit, ChangeDetectorRef, Input, Inject, PLATFORM_ID, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute,Router } from '@angular/router';
import {
  MatSnackBar
} from '@angular/material/snack-bar';

import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { AuthServiceService } from '../../../shared/services/auth-service.service';
import { ConnectionService } from '../../organization/connection.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { TokenUtil } from 'src/app/core/services/TokenUtil.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { EncryptionService } from 'src/app/shared/services/encryption-service';

declare const google: any
export interface userProfile {
  email: string;
  first_name?: string;
  last_name?: string;
  image_url?: string;
}

@Component({
    selector: 'app-login-dialog',
    templateUrl: './login-dialog.component.html',
    styleUrls: ['./login-dialog.component.css'],
    animations: [
        trigger('fade', [
            state('text', style({ color: 'green' })),
            // transition(':enter, :leave', [
            //   animate(2000)
            // ])
            state('void', style({ opacity: 1 })),
            transition('void => *', [
                style({ backgroundColor: 'green', color: 'black', opacity: 0, borderRadius: '5px' }),
                animate(2000, style({ backgroundColor: 'lightblue', color: 'black', opacity: 1, borderRadius: '5px' }))
            ])
        ])
    ],
    standalone: false
})
export class LoginDialogComponent implements OnInit {
  formGroup: UntypedFormGroup;
  signInFormGroup: UntypedFormGroup;
  public auth2: any;
  text = "text"
  loginOptions = [
    { id: 'signin', name: `login-dialog.Sign In` },
    { id: 'signup', name: `login-dialog.Sign Up` },
  ];
  loginToggle: string = 'signin';
  post: any = '';
  hide = true;
  password: string;
  signinBtnBusy: boolean = false;
  serverBaseUrl = environment.SERVER_BASE_URL;
  authenticationType: string = 'manual';
  userProfile: any = {};
  spinner: boolean = false;
  navigateParams: any;
  duplicateSignupError: boolean = false

  @Input() "selectedWorkspace": any;
  @Input() "isSignOut": boolean;
  @Input() inputParams:any
  @Input() hidetitle: any = false;
  @Input() noRedirect: any = false;
  @Output() loggedInUser = new EventEmitter<any>();
  @Output() isLoginSubmitted = new EventEmitter<any>();

  isFromMobile: boolean;
  isBrowser: boolean;
  loginFailed: boolean;

  constructor(
    private snackBar: MatSnackBar,
    // public dialogRef: MatDialogRef<LoginDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    public authService: AuthServiceService,
    public connectionService: ConnectionService,
    public translate: TranslateService,
    private tokenUtil: TokenUtil,
    private encryptionService: EncryptionService,
    @Inject(PLATFORM_ID) platformId?: Object,
    @Inject(DOCUMENT) private document?: Document
    ) {
      this.isBrowser = isPlatformBrowser(platformId);
      if(!this.isBrowser) return;
    }

  ngOnInit(): void {
    if(!this.isBrowser) return;
    console.log("environment", environment)

    if (this.inputParams) {
      this.loginFromMobile(this.inputParams);
    }

    // Retrieve stored navigation params from AuthService
    this.navigateParams = this.authService.navigateParams;

    // If no stored params, check query params

    this.route.queryParams.subscribe(params => {

      if (!this.navigateParams) this.navigateParams = {};
      // if (params?.entityType) {
      //   this.navigateParams.entityType = params.entityType;
      //   // Store the params in AuthService for future use
      // }

      if(Object.keys(params).length) Object.assign(this.navigateParams, params)
      this.authService.navigateParams = this.navigateParams;
      console.log("queryParams: ", this.navigateParams)

    });


    this.createForm();
    this.createSignInForm();
  }
  trackByFn(index:number, item:any):any{
    return item || index
  }

  async ngAfterViewInit() {
    if(!this.isBrowser) return;
    if(this.authService.isFromMobile) return;
    this.signinBtnBusy = true;

    google.accounts.id.initialize({
      client_id:  environment.GOOGLE_CLIENT,
      callback: this.handleCredentialResponse.bind(this),
      ux_mode: "popup",
      use_fedcm_for_prompt: true,
      auto_select: true
    });

    this.renderGoogleButton();
    // google.accounts.id.prompt(); // also display the One Tap dialog
    this.signinBtnBusy = false;
    this.cdr.detectChanges();
  }

  /**
 * Renders the Google Sign-In button and ensures it's visible.
 */
  private renderGoogleButton(retryCount: number = 0) {
    const buttonDiv = this.document.getElementById("buttonDiv");

    if(retryCount) google.accounts.id.renderButton(buttonDiv, {
      theme: "filled_blue",
      logo_alignment: "left",
      text: "signin_with",
      type: "standard",
      shape: "rectangular"
    });
    this.cdr.detectChanges();

    // Ensure the button is visible, retring if not vissible //3 times
    setTimeout(() => {
      if (!buttonDiv.hasChildNodes() && retryCount < 3) {
          console.warn("Google Sign-In button not rendered. Retrying...");
          this.renderGoogleButton(retryCount + 1);
      }
    }, 1000);
  }

  async loginFromMobile(params?: any){
    if(params.origin && params.origin == 'mobile'){
      this.authService.isFromMobile = true;
      this.authService.origin = params.origin;
      console.log('params.idtoken', params.idtoken);
      if(params.idtoken){
        var userMap = this.tokenUtil.getDecodedJWT(params.idtoken);
        console.log("email", userMap.email)
        this.constructAndhandleLogin(params.idtoken);
      }
    }
  }

  async constructAndhandleLogin(idToken:any){
    let cred = {
      credential: idToken
    }
    this.handleCredentialResponse(cred);
  }

  async handleCredentialResponse(e){
    this.isLoginSubmitted.emit(true);
    console.log("handleCredentialResponse", e);
    console.log("this", this);
    this.loginFailed = false;
    console.log("tokenUtil", this.tokenUtil.getDecodedJWT(e.credential))
    var userMap = this.tokenUtil.getDecodedJWT(e.credential);
    let that = this;
    this.spinner = true;
    that.userProfile.email = userMap.email;
    that.userProfile.first_name = userMap?.given_name;
    that.userProfile.last_name = userMap?.family_name;
    that.userProfile.image_url = userMap?.picture;

    that.authService.loggedInProfile = that.userProfile;
    console.log(that.authService.loggedInProfile)

    console.log("that.userProfile", that.userProfile);
    that.authenticationType = 'google';
    this.authService.authenticationType = this.authenticationType;
    this.authService.userProfile = that.userProfile
    console.log("that.authenticateType", that.authenticationType);
    let options = {authType: this.authenticationType, storeAuth: true};
    let isLoginSuccess = await this.authService.checkAndCreateUser(options);
    if(!isLoginSuccess) {
      this.loginFailed = true;
      console.log("login failed")
      return;
    }

    if(this.noRedirect) {
      this.loggedInUser.emit(true)
      return;
    }

    if(this.navigateParams?.entityType == 'connection'){
      let workspaceId = await this.connectionService.getWorkSpaceId(this.userProfile.email)
      let preauthenticataedToken = await this.connectionService.getPreAuthenticatedTokenForEmail(this.userProfile.email)
      this.router.navigate(['connection'], {queryParams: {workspaceid: workspaceId,authorization: preauthenticataedToken}})
    } else if(this.navigateParams?.entityType == 'flow'){
      this.router.navigate(['flow'])
    } else if(this.navigateParams?.entityType == 'starch'){
      this.router.navigate(['starch'])
    } else if(this.navigateParams?.entityType == 'flow-signup'){
      this.router.navigate(['flow', 'sign-up'], { queryParams: this.navigateParams})
    } else if(this.navigateParams?.entityType == 'bloom'){
      this.router.navigate(['bloom'])
    } else {
      this.router.navigate(['/home'], { queryParams: { selected_workspace: this.selectedWorkspace }})
    }
  }


  onSignInFailure(param) { }

  closeModal() {
    // this.dialogRef.close();
  }

  async onSubmitSignIn(post) {
    this.spinner = true;
    this.isLoginSubmitted.emit(true);
    this.userProfile.email = post.email;
    this.authenticationType = 'manual';
    this.authService.authenticationType = this.authenticationType;
    this.password = this.encryptionService.encryptUsingAES256(post.password);
    let existingProfile: any = await this.checkPasswordAndGetUser();
    this.spinner = false;
    if (existingProfile) {
      var sessionObject = this.encryptionService.encryptUsingAES256({
        userSignInTime: (new Date()).getTime(),
        user: existingProfile
      })
      sessionStorage.setItem('_AWuserSession', sessionObject);
      this.authService.loggedIn = true;
      this.authService.profile = existingProfile;
      this.authService.setOrganization(existingProfile);
      if(this.noRedirect) {
        this.loggedInUser.emit(true)
        return;
      }
      if(this.navigateParams?.entityType == 'connection'){
        let workspaceId = await this.connectionService.getWorkSpaceId(this.userProfile.email)
        let preauthenticataedToken = await this.connectionService.getPreAuthenticatedTokenForEmail(this.userProfile.email)
        this.router.navigate(['connection'], {queryParams: {workspaceid: workspaceId,authorization: preauthenticataedToken}})
      } else if(this.navigateParams?.entityType == 'flow'){
        this.router.navigate(['flow'])
      } else if(this.navigateParams?.entityType == 'starch'){
        this.router.navigate(['starch'])
      } else {
        this.router.navigate(['/home'], { queryParams: { selected_workspace: this.selectedWorkspace }})
      }
    }
  }

  async checkPasswordAndGetUser() {
    let that = this;
    this.spinner = true;
    var result = null
    let url = `${this.serverBaseUrl}/user/checkuserpassword/${this.userProfile.email}/${this.password}`;
    var promise = this.http.get(url).toPromise();
    await promise.then((data: any) => {
      console.log("checkuserpassword add getuser resolved with:", data);
      if(!data) throw {status: "NOT_FOUND"}
      result = data;
    }).catch((error) => {
      console.log("Error while check user password user", error)
      var message = ''
      if (error.error && error.error.status == "PASSWORD_MISMATCH") {
        message = this.translate.instant(`login-dialog.PASSWORD_MISMATCH`);
      } else if (error.error && error.error.status == "NOT_FOUND") {
        message = this.translate.instant(`login-dialog.NOT_FOUND`);
      } else if (error.error && error.error.status == "WORNG_AUTHENTICATION_TYPE") {
        message = this.translate.instant(`login-dialog.WORNG_AUTHENTICATION_TYPE`);
      } else {
        message = this.translate.instant(`login-dialog.NOT_FOUND`);
      }
      this.spinner = false;
      this.openSnackBar(message);
      throw error;
    });
    this.spinner = false;
    return result;
  }

  async onSubmit(post) {
    this.isLoginSubmitted.emit(true);
    if (this.formGroup.status == "VALID") {
      this.spinner = true;
      this.post = post;
      console.log('post', post);
      this.userProfile.email = post.email;
      this.userProfile.first_name = post.firstName;
      this.userProfile.last_name = post.lastName;
      this.password = this.encryptionService.encryptUsingAES256(post.password);
      let existingProfile: any = await this.authService.getWorkspaceUser(post.email);
      console.log("existing profile", existingProfile)
      this.authenticationType = 'manual';
      this.authService.authenticationType = this.authenticationType;
      console.log("existingProfile", existingProfile)
      this.spinner = false;
      if (!existingProfile) {
        await this.authService.checkAndCreateUser({password: this.password, isNewUser: true, user_profile: this.userProfile});
        console.log("returned to login dialog")
        var sessionObject = this.encryptionService.encryptUsingAES256({
          userSignInTime: (new Date()).getTime(),
          user: this.userProfile
        })
        sessionStorage.setItem('_AWuserSession', sessionObject);
        if(this.noRedirect) {
          this.loggedInUser.emit(true)
          return;
        }
        this.router.navigate(['/home'], { queryParams: { selected_workspace: this.selectedWorkspace }})
      } else {
        console.log("User already exists try login")
        this.snackBar.open("Email is already registered. Try signing in.", "", { duration: 3000 })
        this.duplicateSignupError = true
      }
    }
  }

  gotoSignin(){
    this.duplicateSignupError = false
    this.formGroup.reset()
    this.loginToggle = 'signin'
    this.signInFormGroup.patchValue({
      email: this.userProfile.email
    })
  }

  openSnackBar(message) {
    this.snackBar.open(message, 'close', {
      horizontalPosition: "center",
      verticalPosition: "bottom",
    });
  }

  //-------form validations---------//
  get name() {
    return this.formGroup.get('name') as UntypedFormControl;
  }

  createForm() {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.formGroup = this.formBuilder.group(
      {
        email: [
          null,
          [Validators.required, Validators.pattern(emailregex)],
          this.checkInUseEmail,
        ],
        firstName: [null, Validators.required],
        lastName: [null, Validators.required],
        password: [null, [Validators.required, this.checkPassword]],
        confirmPassword: [null, [Validators.required]],
        validate: '',
      },
      { validators: this.confirmedValidator('password', 'confirmPassword') }
    );
  }

  createSignInForm() {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.signInFormGroup = this.formBuilder.group(
      {
        email: [
          null,
          [Validators.required, Validators.pattern(emailregex)],
          this.checkInUseEmail,
        ],
        password: [null, [Validators.required, this.checkPassword]]
      }
    );
  }

  confirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors.confirmedValidator
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  checkPassword(control) {
    let enteredPassword = control.value;
    let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
    return !passwordCheck.test(enteredPassword) && enteredPassword
      ? { requirements: true }
      : null;
  }
  checkPasswords(formGroup: UntypedFormGroup) {
    // here we have the 'passwords' group
    console.log(formGroup);
    const password = formGroup.get('password').value;
    const confirmPassword = formGroup.get('confirmPassword').value;

    return password === confirmPassword ? null : { notSame: true };
  }

  checkInUseEmail(control) {
    // mimic http database access
    let db = ['best@gmail.com'];
    return new Observable((observer) => {
      setTimeout(() => {
        let result =
          db.indexOf(control.value) !== -1 ? { alreadyInUse: true } : null;
        observer.next(result);
        observer.complete();
      }, 4000);
    });
  }

  getConfirmPassword() {
    console.log('sss');
    return this.formGroup.get('confirmPassword').hasError('notSame')
      ? this.translate.instant(`login-dialog.Password Mismatch`)
      : '';
  }

  getErrorEmail() {
    return this.formGroup.get('email').hasError('required')
      ? this.translate.instant(`login-dialog.Field is required`)
      : this.formGroup.get('email').hasError('pattern')
        ? this.translate.instant(`login-dialog.Not a valid email Address`)
        : this.formGroup.get('email').hasError('alreadyInUse')
          ? this.translate.instant(`login-dialog.This email Address is already in use`)
          : '';
  }

  getErrorPassword(type?:any) {
    let field = "Password_Require";
    if(type == "signin") field = "Field_Require";
    return this.formGroup.get('password').hasError('required')
      ? this.translate.instant(`login-dialog.${field}`)
      : this.formGroup.get('password').hasError('requirements')
        ? this.translate.instant(`login-dialog.Password_Requirements`)
        : '';
  }
}
